"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixpanelLog = void 0;
// import mixpanel from "mixpanel-browser";
var mixpanel = require('mixpanel-browser');
var MixpanelLog = /** @class */ (function () {
    function MixpanelLog(mixpanel_token) {
        var _this = this;
        this.send = function (key, data) {
            if (data === void 0) { data = {}; }
            _this._client.track(key, data);
        };
        mixpanel.init(mixpanel_token, { debug: false });
        this._client = mixpanel;
    }
    return MixpanelLog;
}());
exports.MixpanelLog = MixpanelLog;
